import React from "react";
import { Alert } from "antd";

const ErrorSection = ({ error }) => {
  if (!error) return null;
  const keys = Object.keys(error);
  const message = (
    <>
      {keys.map(key => 
        <div key={key}>{error[key].detail}</div>
      )}
    </>
  );

  return (
    <Alert message={message} type="error" showIcon closable style={{ marginBottom: 24 }} />
  );
};

export default ErrorSection;
